<template>
  <div v-if="paymentMethods.length" :class="!isPdp && 'pt-2'">
    <div
      class="flex"
      :class="
        isPdp
          ? 'justify-start max-w-sm gap-2'
          : 'flex-wrap items-stretch justify-center gap-1 sm:justify-start'
      "
    >
      <div
        v-for="({ icon, title }, itemIndex) in paymentMethods"
        :key="itemIndex"
        :class="{
          'flex items-center bg-transparent px-1': !icon?.filename,
        }"
      >
        <span class="min-w-auto flex h-[35px]" :title="title">
          <!-- Plain <img>: SVG icons need no responsive srcset (ECOM-2361). -->
          <img
            v-if="icon?.filename"
            :src="icon.filename"
            :alt="title"
            class="h-[35px] w-auto"
          />
          <span v-else>{{ title }}</span>
        </span>
      </div>
    </div>
    <div v-if="isPdp && paypalMethod" class="pt-4 text-base">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="renderPaypalInfo" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type {
  SbFooterInfoItem,
  SbPaymentMethod,
} from '~/cms/storyblok/types/storyblok.gen'
import { useI18n } from '#i18n'

const i18n = useI18n()
const paypalIconUrl = new URL(
  '@/assets/icons/paypal-logo-blue.svg',
  import.meta.url,
).href

const props = withDefaults(
  defineProps<{
    paymentMethods?: (SbPaymentMethod | SbFooterInfoItem)[]
    isPdp?: boolean
  }>(),
  {
    paymentMethods: () => [],
    isPdp: false,
  },
)

const paypalMethod = computed(() =>
  props.paymentMethods.find(
    ({ title }) => title?.toLocaleLowerCase() === 'paypal',
  ),
)

const renderPaypalInfo = computed(() => {
  if (!paypalMethod.value) {
    return ''
  }
  const paypalIconHtml = `<img src="${paypalIconUrl}" alt="PayPal" class="inline-block h-[0.875rem]" />`
  return i18n.t(
    'pdp.payment_methods.paypal_info',
    {
      paypalIcon: paypalIconHtml,
    },
    { escapeHtml: false } as any,
  )
})
</script>
